import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { useCallback } from "react";
import { graphScopes } from "./authConfig";

export function useGraphToken() {
  const { instance, accounts } = useMsal();

  return useCallback(async (): Promise<string> => {
    const account = instance.getActiveAccount() ?? accounts[0];
    if (!account) {
      throw new Error("No signed-in account.");
    }
    try {
      const result = await instance.acquireTokenSilent({
        account,
        scopes: graphScopes,
      });
      return result.accessToken;
    } catch (err) {
      if (err instanceof InteractionRequiredAuthError) {
        const result = await instance.acquireTokenPopup({ scopes: graphScopes });
        return result.accessToken;
      }
      throw err;
    }
  }, [accounts, instance]);
}
